/**
 * All appointment related socket events
 */
const apptSocketEvents = Object.freeze({
    CUSTOMER_APPT_CREATED: 'CUSTOMER_APPT_CREATED',
});

export { apptSocketEvents };